/**
 * Sorting strategies object containing different sorting methods
 */
const strategies = {
  title: (a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: "base" }),
  title_desc: (a, b) =>
    b.title.localeCompare(a.title, undefined, { sensitivity: "base" }),
  date: (a, b) => new Date(b.date) - new Date(a.date),
  rating: (a, b) => b.averageRating - a.averageRating,
  news: (a, b) => b.averageRating - a.averageRating,
  type: (a, b) => a.type.localeCompare(b.type),
  default: (a, b) =>
    a.title.localeCompare(b.title, undefined, { sensitivity: "base" }),
};

/**
 * Sorts an array of items by the specified sort type
 * @param {Array} items - Array of items to sort
 * @param {string} sortBy - Sort type to use (title, date, rating, news, type)
 * @returns {Array} Sorted array of items
 */
const sort = (items, sortBy) => {
  if (!Array.isArray(items)) {
    return [];
  }
  const sorter = strategies[sortBy?.toLowerCase()] || strategies.default;
  return [...items].sort(sorter);
};

/**
 * Gets sorted items using a custom sorter function
 * @param {Array} items - Array of items to sort
 * @param {Function} sorter - Custom sorting function
 * @returns {Array} Sorted array of items
 */
const getSortedItems = (items, sorter) => {
  return Array.isArray(items) ? [...items].sort(sorter) : [];
};

/**
 * Updates a list object by sorting its courses property
 * @param {Object} items - Object containing a courses array
 * @param {string} sortBy - Sort type to use
 * @returns {Object} Updated object with sorted courses
 */
const updateList = (items, sortBy) => {
  if (!items) {
    return { courses: [] };
  }

  const sorter = strategies[sortBy?.toLowerCase()] || strategies.default;
  const sortedItems = getSortedItems(items.courses, sorter);

  return {
    ...items,
    courses: sortedItems,
  };
};

/**
 * Sort service object containing all sorting methods
 */
export const sortService = {
  sort,
  updateList,
};
